import { render, staticRenderFns } from "./BaseSimpleModal.vue?vue&type=template&id=4e4d301f&"
import script from "./BaseSimpleModal.vue?vue&type=script&lang=js&"
export * from "./BaseSimpleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports